import { CheckboxField, IStyleConfig } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../common/state/app_state';
import { IJsonQueryInfrastructureParams } from '../../../../../json_query';
import { IInfrastructureParamChangedAction } from '../../../../state/advanced/infrastructure';
const style = require('../../index.css');

export interface ICheckboxParamProps {
  value: boolean;
  onValueChange(value: boolean): void;
}

export const getCheckboxParam = (
  title: string,
  jsonQueryParamName: keyof IJsonQueryInfrastructureParams,
  changeHandler: (value: boolean) => IInfrastructureParamChangedAction,
  checkboxStyles?: IStyleConfig,
) => {
  const CheckboxParam: React.StatelessComponent<ICheckboxParamProps> = props => (
    <div className={style['checkboxDiv']}>
      <CheckboxField
        label={title}
        value={props.value}
        onValueChange={props.onValueChange}
        containerStyle={checkboxStyles}
      />
    </div>
  );

  return connect(
    (state: IAppState) => {
      const param = (state.filters.jsonQuery as IJsonQueryInfrastructureParams)[jsonQueryParamName];

      return {
        value: !!param && param.value,
      };
    },
    (dispatch: Dispatch) => ({
      onValueChange: (value: boolean): void => {
        dispatch(changeHandler(value));
      },
    }),
  )(CheckboxParam);
};
